<template>
  <div class="tour">
    <div class="top" :class="{default : tourinfo.course_image_file_1 == ''}" v-bind:style="{ 'background-image': 'url(' + 'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/courses/' + id + '/' +  tourinfo.course_code + '/' + tourinfo.course_image_file_1 + ')' }">
       <!-- Show Desktop -->
      <div class="desktopOnly container">
        <b-row :class="[splashText]">
          <b-col :class="[overlay]" class="leftCol" lg="12" md="12" cols="12">
            <b-row class="above990">
              <b-col lg="8" md="10" cols="12" class="noPadTop">
                <div class="tourBox"  :style="colourTour">
                  <template v-if="tournID == 'cpt'">Tier 1</template>
                  <template v-else-if="tournID == 'cp2'">Tier 2</template>
                  <template v-else-if="tournID == 'cp3'">Amateur</template>
                  <template v-else-if="tournID == 'pam'">Pro-Ams</template>
                  <template v-else-if="tournID == 'por'">Portugal Series</template>
                  <template v-else-if="tournID == 'qsc'">Q-School</template>
                </div>
                <h2 class="fullName-width">
                  <template v-if="tourinfo.use_full_name == 'N'">
                    {{ tourinfo.short_name }} <span v-if="tourinfo.cancelled == 'Y'"> - Cancelled</span>
                  </template>
                  <template v-else>
                    {{ tourinfo.full_name }} <span v-if="tourinfo.cancelled == 'Y'"> - Cancelled</span>
                  </template>
                </h2>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <!-- Show Mobile -->
      <div class="showMobile">
        <div class="tourBox" :style="colourTour">
          <template v-if="tournID == 'cpt'">Tier 1</template>
          <template v-else-if="tournID == 'cp2'">Tier 2</template>
          <template v-else-if="tournID == 'cp3'">Amateur</template>
          <template v-else-if="tournID == 'pam'">Pro-Ams</template>
          <template v-else-if="tournID == 'por'">Portugal Series</template>
          <template v-else-if="tournID == 'qsc'">Q-School</template>
        </div>
        <h2 class="fullName-width">
          {{ tourinfo.full_name }} <span v-if="tourinfo.cancelled == 'Y'"> - Cancelled</span>
        </h2>
      </div>
    </div>

    <!-- Images to appear overlay -->
    <b-row class="imagefilesPos">
      <b-col class="imageSize" lg="" sm="6" v-for="(image, index) in imagefiles" :key="'fourtysixdex' +index" v-show="image.ad_lcc == 'N' && image.ad_file != ''">
        <b-link :href="image.ad_link" :title="image.ad_desc" target="_blank">
          <div class="imagefileImage" v-bind:style="{ 'background-image': 'url(' + image.ad_file + ')' }"></div>
        </b-link>
      </b-col>
    </b-row>

    <!-- Tournament Information Section -->
    <!-- Desktop Section -->
    <div class="desktopOnly">
      <div class="backgroundGrey">
        <b-container>
          <!-- Desktop View -->
          <b-row class="above990">
            <b-col class="leftCol" style="padding-right:1px;">
              <h2 class="splashPad">
                Tournament Info 
              </h2>
              <b-row>
                <b-col lg="12" class="noPadLeft">
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Course Dates
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.dates }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Rounds
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.rounds }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Prize Fund
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.total_prize_fund }} <button v-if="showFund == true" id="show-btn" @click="$bvModal.show('bv-modal-example')">See Prize Breakdown</button>
                      </h3>
                    </b-col>
                  </b-row>
                   <!-- Prize Fund breakdown -->
                  <b-modal id="bv-modal-example" hide-footer >
                    <!-- <template #modal-title>
                      Using <code>$bvModal</code> Methods
                    </template> -->
                    <div class="d-block text-center">
                      <h2 class="HeaderText">{{prizeFundDataName}}</h2>
                      <table>
                        <thead>
                          <tr>
                            <th class="mobileTab">Position</th>
                            <th class="mobileTab">Prize Fund</th>
                            <th class="mobileTab hideOnMobile">Prize Percentage</th>
                          </tr>
                        </thead>
                        <body class="fundBReak">
                          <tr v-for="(fund, index2) in prizeFundData" :key="index2">
                            <td class="mobileTab">{{index2 + 1}}</td>
                            <td class="mobileTab">{{fund.fund_prize}}</td>
                            <td class="mobileTab hideOnMobile">{{fund.fund_perc}}</td>
                          </tr>
                        </body>
                      </table>

                    </div>
                    <!-- <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close Me</b-button> -->
                  </b-modal>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Field Size
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.field_size }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.previous_winners.previous_winners_entry.cc_name_1 !== ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                      Previous Winner
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.previous_winners.previous_winners_entry.cc_name_1 }}
                      </h3>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="leftCol">
              <h2 class="splashPad">
                About the Course
              </h2>
              <b-row>
                <b-col lg="12" class="noPadLeft">
                  <b-row class="rowPad" v-if="tourinfo.course_name != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Course Name
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_city != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        City
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_city }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_country != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Country
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_country }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_website != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Website
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        <template v-if="tourinfo.course_website.includes('https') || tourinfo.course_website.includes('http')">
                          <a
                            v-bind:href="tourinfo.course_website"
                            target="_blank"
                            >{{ tourinfo.course_website }}</a
                          >
                        </template>
                        <template v-else>
                          <a
                            v-bind:href="'https://' + tourinfo.course_website"
                            target="_blank"
                            >{{ tourinfo.course_website }}</a
                          >
                        </template>
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_total_par != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Par
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_total_par }}
                      </h3>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="leftCol" v-if="tourinfo.winner_found === 'Y' || tourinfo.previous_winners.previous_winners_entry.cc_code_1 != ''">
              <h2 class="splashPad" v-if="tourinfo.winner_found === 'Y'">
                Winner
              </h2>
              <h2 class="splashPad" v-else>
                Previous Winner
              </h2>
              <template v-if="tourinfo.winner_found === 'Y'">
                <b-row>
                  <b-col lg="4" class="imagePad">
                    <template v-if="tourinfo.winner_image == 'Y'">
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/test.jpg'
                        "
                      ></b-img>
                    </template>
                    <!-- <template v-if="tourinfo.winner_image == 'Y'">
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/test.jpg'
                        "
                      ></b-img>
                    </template> -->
                    <template v-else>
                      <b-link :href="playerImages[0].smug_web_url" target='_blank'>
                        <img class="mainImg" :src="playerImages[0].smug_thumbnail">
                      </b-link>
                    </template>
                  </b-col>
                  <b-col lg="8" class="winnerNameBlock">
                    <p class="winnerName">
                        {{ tourinfo.winner_name }}
                    </p>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="4" class="imagePad">
                    <template v-if="tourinfo.previous_winners.previous_winners_entry.cc_code_1 !== ''">
                      <b-link :href="playerImages[0].smug_web_url" target='_blank'>
                        <img class="mainImg" :src="playerImages[0].smug_thumbnail">
                      </b-link>
                    </template>
                    <template v-else>
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/test.jpg'
                        "
                      ></b-img>
                    </template>
                  </b-col>
                  <b-col lg="8" class="winnerNameBlock">
                    <p>
                      <a :href="'/playerprofile/' + tourinfo.previous_winners.previous_winners_entry.cc_code_1" class="playerProfileLink">
                        {{ tourinfo.previous_winners.previous_winners_entry.cc_name_1 }}
                      </a>
                    </p>
                      <img
                        v-if="tourinfo.previous_winners.previous_winners_entry.cc_nat_1 != ''"
                        class="insideflag"
                        :src="
                          (config.VUE_APP_FLAG_URL +
                            tourinfo.previous_winners.previous_winners_entry.cc_nat_1)
                            | lowercase
                        "
                      />
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
          <!-- Below Desktop View -->
          <b-row class="below990">
            <b-col lg="12" md="10" cols="12" class="">
              <div class="tourBox"  :style="colourTour">
                <template v-if="tournID == 'cpt'">Tier 1</template>
                <template v-else-if="tournID == 'cp2'">Tier 2</template>
                <template v-else-if="tournID == 'cp3'">Amateur</template>
                <template v-else-if="tournID == 'pam'">Pro-Ams</template>
                <template v-else-if="tournID == 'qsc'">Q-School</template>
              </div>
            </b-col>
            <b-col>
              <h2 class="fullName-width">
                <template v-if="tourinfo.use_full_name == 'N'">
                  {{ tourinfo.short_name }}
                </template>
                <template v-else>
                  {{ tourinfo.full_name }}
                </template>
              </h2>
            </b-col>
            <b-col class="leftCol" lg="12">
              <h2 class="splashPad">
                Tournament Info 
              </h2>
              <b-row>
                <b-col lg="12" class="noPadLeft">
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Course Dates
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.dates }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Rounds
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.rounds }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Prize Fund
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.total_prize_fund }} 
                      </h3>
                      <button v-if="showFund == true" id="show-btn" @click="$bvModal.show('bv-modal-example')">See Prize Breakdown</button>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Field Size
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.field_size }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row style="display:none" class="rowPad" v-if="tourinfo.previous_winners.previous_winners_entry.cc_name_1 !== ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                      Previous Winner
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.previous_winners.previous_winners_entry.cc_name_1 }}
                      </h3>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="leftCol" lg="12">
              <h2 class="splashPad">
                About the Course
              </h2>
              <b-row>
                <b-col lg="12" class="noPadLeft">
                  <b-row class="rowPad" v-if="tourinfo.course_name != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Course Name
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_name }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_city != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        City
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_city }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_country != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Country
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_country }}
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_website != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Website
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        <template v-if="tourinfo.course_website.includes('https') || tourinfo.course_website.includes('http')">
                          <a
                            v-bind:href="tourinfo.course_website"
                            target="_blank"
                            >{{ tourinfo.course_website }}</a
                          >
                        </template>
                        <template v-else>
                          <a
                            v-bind:href="'https://' + tourinfo.course_website"
                            target="_blank"
                            >{{ tourinfo.course_website }}</a
                          >
                        </template>
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row class="rowPad" v-if="tourinfo.course_total_par != ''">
                    <b-col lg="4">
                      <h3 class="underLine">
                        Par
                      </h3>
                    </b-col>
                    <b-col>
                      <h3 class="valuesize rightside-changes">
                        {{ tourinfo.course_total_par }}
                      </h3>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col style="display:none" class="leftCol" lg="12" v-if="tourinfo.winner_found === 'Y' || tourinfo.previous_winners.previous_winners_entry.cc_name_1 != ''">
              <h2 class="splashPad" v-if="tourinfo.winner_found === 'Y'">
                Winner
              </h2>
              <h2 class="splashPad" v-else>
                Previous Winner
              </h2>
              <template v-if="tourinfo.winner_found === 'Y'">
                <b-row>
                  <b-col lg="4" class="imagePad">
                    <!-- <template v-if="tourinfo.winner_image == 'Y'">
                      <b-img
                        class="mainImg"
                        :src="
                          'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/' +
                          tourinfo.winner_code + '.jpg'
                        "
                      ></b-img>
                    </template> -->
                    <template v-if="tourinfo.winner_image == 'Y'">
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/test.jpg'
                        "
                      ></b-img>
                    </template>
                    <template v-else>
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/06/dummy-image.jpg'
                        "
                      ></b-img>
                    </template>
                  </b-col>
                  <b-col lg="8" class="winnerNameBlock">
                    <p class="winnerName">
                        {{ tourinfo.winner_name }}
                    </p>
                  </b-col>
                </b-row>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="4" class="imagePad">
                    <template v-if="tourinfo.previous_winners.previous_winners_entry.cc_code_1 !== ''">
                      <b-img
                        class="mainImg"
                        :src="
                          'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/' +
                          tourinfo.previous_winners.previous_winners_entry.cc_code_1 + '.jpg'
                        "
                      ></b-img>
                    </template>
                    <template v-else>
                      <b-img
                        class="mainImg"
                        :src="
                          'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/06/dummy-image.jpg'
                        "
                      ></b-img>
                    </template>
                  </b-col>
                  <b-col lg="8" class="winnerNameBlock">
                    <p>
                      <a :href="'/playerprofile/' + tourinfo.previous_winners.previous_winners_entry.cc_code_1" class="playerProfileLink">
                        {{ tourinfo.previous_winners.previous_winners_entry.cc_name_1 }}
                      </a>
                    </p>
                      <img
                        v-if="tourinfo.previous_winners.previous_winners_entry.cc_nat_1 != ''"
                        class="insideflag"
                        :src="
                          (config.VUE_APP_FLAG_URL +
                            tourinfo.previous_winners.previous_winners_entry.cc_nat_1)
                            | lowercase
                        "
                      />
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Course Information Section -->
    <div class="coursInfoWritten" v-if="tourinfo.course_para1 != ''">
      <b-container>
        <h2 class="HeaderText courseInformation">Course Information</h2>
        <b-row>
          <b-col class="paragraph-Padding">
            <p v-if="Object.keys(tourinfo.course_para1).length === 0"></p>
            <p class="paraText">
              {{ tourinfo.course_para1 }}
            </p>
            <p v-if="Object.keys(tourinfo.course_para2).length === 0"></p>
            <p class="paraText">
              {{ tourinfo.course_para2 }}
            </p>
            <p v-if="Object.keys(tourinfo.course_para3).length === 0"></p>
            <p v-else class="paraText"> 
              {{ tourinfo.course_para3 }}
            </p>
            <p v-if="Object.keys(tourinfo.course_para4).length === 0"></p>
            <p class="paraText">
              {{ tourinfo.course_para4 }}
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container>
      <!-- Reports Section -->
      <div v-if="this.tourinfo.reports != ''">
        <div v-if="hideLoader == false">
          <div class="insideLoader">
            <div class="loader"></div>
            <h2 class="HeaderText reportInfo loadReports">Loading Reports</h2>
          </div>
        </div>
        <div v-else>
          <div class="reportSele" v-if="tourinfo.reports !== ''" :class="{extraMargin : tourinfo.course_para1 == ''}">
            <b-row>
              <b-col>
                <div :class="drop" class="reportdrop">
                  <h2 class="HeaderText reportInfo">Select Report</h2>
                  <b-nav card-header pills align="center">
                    <b-dropdown
                      v-if="Array.isArray(tourinfo.reports.reports_entry)"
                      :text="title"
                      :config="config"
                    >
                      <b-dropdown-item
                        v-on:click="changeReport"
                        v-for="(reports, index) in tourinfo.reports.reports_entry"
                        :key="index + Math.random()"
                        :title="reports.report_url"
                        :value="reports.report_title"
                        v-show="
                          reports.report_title !== 'Course Statistics' &&
                          reports.report_title !== 'Scoring Statistics' &&
                          reports.report_title !== 'Course Statistics (GPC)' &&
                          reports.report_title !== 'Course Statistics (LOST)' &&
                          reports.report_title !== 'Statistics Tables' &&
                          reports.report_title !== 'Live Scoring Monitor'
                        "
                        >{{ reports.report_title }}</b-dropdown-item
                      >
                    </b-dropdown>
                    <b-dropdown v-else :text="title">
                      <b-dropdown-item
                        v-on:click="changeReport"
                        v-for="(reports, index) in tourinfo.reports"
                        :key="index + Math.random()"
                        :title="reports.report_url"
                        :value="reports.report_title"
                        >{{ reports.report_title }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-nav>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="multiCourseIndex" v-if="tourinfo.multi_course === 'Y'">
                <span
                  v-for="(course, index) in tourinfo.courses.courses_entry"
                  :key="index + Math.random()"
                  class="multiText"
                >
                  {{ course.course_X_id }} =
                  <span :class="course.course_X_colour" class="multiDot-size"
                    >•</span
                  >
                </span>
              </b-col>
            </b-row>
          </div>
          <b-row v-if="tourinfo.reports !== ''">
            <b-col>
              <div class="tourInfo reportSection tournReportSection">
                <div v-if="title.includes('Score')">
                  <div class="TitleArea">
                    <span v-if="title.includes('Score')">
                      <h3 class="courseDates TitleAreaScore">
                        {{ data.course_dates }}
                      </h3>
                      <h3 class="courseDates lastRealTime-update">
                        Last Real Time Update -
                        {{ data.last_scores_update_date }} - {{ data.course_city }} Time -
                        {{ data.last_scores_update_time }}
                        {{ data.last_scores_update_date }}
                      </h3>
                      <template v-if="showGender == 'Y'">
                        <p class="showPgender">
                          <span class="multiDot-size-reportgender male">• </span> = Men
                          Professional <br />
                          <span class="multiDot-size-reportgender female">• </span> =
                          Ladies Professional
                        </p>
                      </template>
                    </span>
                  </div>
                  <b-tabs content-class="mt-3" class="tabsLi">
                    <template v-if="data.hide_gross_sb == 'Y'">
                      <b-tab title="Leaderboard" active title-item-class="nonactive">
                        <template v-if="data.stableford == 'Y'">
                          <ScoreTeam
                            :data="data"
                            :title="title"
                            :home="false"
                            :config="config"
                            :team="teamEvent"
                            :match="tourinfo.match_play"
                            :code="course_code"
                            :id="id"
                            :showGender="showGender"
                            :is_qualifier="is_qualifier"
                            :stableford="stableford"
                            :show_info_web="show_info_web"
                            :hide_score_card="hide_score_card"
                            :cptTour="tournID"
                          />
                        </template>
                        <template v-else>
                          <ReportTable
                            :data="data"
                            :title="title"
                            :home="false"
                            :config="config"
                            :team="teamEvent"
                            :match="tourinfo.match_play"
                            :code="course_code"
                            :id="id"
                            :showGender="showGender"
                            :is_qualifier="is_qualifier"
                            :stableford="stableford"
                            :show_info_web="show_info_web"
                            :hide_score_card="hide_score_card"
                            :cptTour="tournID"
                          />
                        </template>
                      </b-tab>
                      <b-tab title="Hole-By-Hole" title-item-class="nonactive HBH">
                        <HBH
                          :data="data"
                          :previousData="previousData"
                          :config="config"
                          :title="title"
                          :showGender="showGender"
                          :show_info_web="show_info_web"
                          :hide_score_card="hide_score_card"
                          :code="course_code"
                          :id="id"
                        />
                      </b-tab>
                    </template>
                    <template v-else>
                      <template v-if="data.tt_code == '2B'">
                        <b-tab
                          active
                          title="Leaderboard"
                          title-item-class="nonactive"
                        >
                          <template v-if="data.stableford == 'Y'">
                            <ScoreTeam
                              :data="data"
                              :title="title"
                              :home="false"
                              :config="config"
                              :team="teamEvent"
                              :match="tourinfo.match_play"
                              :code="course_code"
                              :id="id"
                              :showGender="showGender"
                              :is_qualifier="is_qualifier"
                              :stableford="stableford"
                              :show_info_web="show_info_web"
                              :hide_score_card="hide_score_card"
                              :cptTour="tournID"
                            />
                          </template>
                          <template v-else>
                            <ReportTable
                              :data="data"
                              :title="title"
                              :home="false"
                              :config="config"
                              :team="teamEvent"
                              :match="tourinfo.match_play"
                              :code="course_code"
                              :id="id"
                              :showGender="showGender"
                              :is_qualifier="is_qualifier"
                              :stableford="stableford"
                              :show_info_web="show_info_web"
                              :hide_score_card="hide_score_card"
                              :cptTour="tournID"
                            />
                          </template>
                        </b-tab>
                        <b-tab title="Hole-By-Hole" title-item-class="nonactive HBH">
                          <HBH
                            :data="data"
                            :previousData="previousData"
                            :config="config"
                            :title="title"
                            :showGender="showGender"
                            :show_info_web="show_info_web"
                            :hide_score_card="hide_score_card"
                            :code="course_code"
                            :id="id"
                          />
                        </b-tab>
                      </template>
                      <template v-else>
                        <b-tab title="Leaderboard" active title-item-class="nonactive">
                          <ReportTable
                            :data="data"
                            :title="title"
                            :home="false"
                            :config="config"
                            team="N"
                            :match="tourinfo.match_play"
                            :code="course_code"
                            :season="id"
                            :showGender="showGender"
                            :is_qualifier="is_qualifier"
                            :stableford="stableford"
                            :show_info_web="show_info_web"
                            :hide_score_card="hide_score_card"
                            :useName="useName"
                            :ReportcolourTour="ReportcolourTour"
                            :cptTour="tournID"
                          />
                        </b-tab>
                        <b-tab
                          title="Team"
                          v-if="teamEvent === 'Y'"
                          title-item-class="nonactive"
                        >
                          <template v-if="data.stableford == 'Y'">
                            <ScoreTeam
                              :data="data"
                              :title="title"
                              :home="false"
                              :config="config"
                              :team="teamEvent"
                              :match="tourinfo.match_play"
                              :code="course_code"
                              :id="id"
                              :showGender="showGender"
                              :is_qualifier="is_qualifier"
                              :stableford="stableford"
                              :show_info_web="show_info_web"
                              :hide_score_card="hide_score_card"
                              :cptTour="tournID"
                            />
                          </template>
                          <template v-else>
                            <ReportTable
                              :data="data"
                              :title="title"
                              :home="false"
                              :config="config"
                              :team="teamEvent"
                              :match="tourinfo.match_play"
                              :code="course_code"
                              :id="id"
                              :showGender="showGender"
                              :is_qualifier="is_qualifier"
                              :stableford="stableford"
                              :show_info_web="show_info_web"
                              :hide_score_card="hide_score_card"
                              :cptTour="tournID"
                            />
                          </template>
                        </b-tab>
                        <b-tab title="Hole-By-Hole" title-item-class="nonactive HBH">
                          <HBH
                            :data="data"
                            :previousData="previousData"
                            :config="config"
                            :title="title"
                            :showGender="showGender"
                            :show_info_web="show_info_web"
                            :hide_score_card="hide_score_card"
                            :code="course_code"
                            :id="id"
                          />
                        </b-tab>
                      </template>
                    </template>
                  </b-tabs>
                </div>
                <div v-else>
                  <ReportTable
                    :data="data"
                    :title="title"
                    :home="false"
                    :config="config"
                    :team="team"
                    :match="tourinfo.match_play"
                    :code="course_code"
                    :season="id"
                    :showGender="showGender"
                    :is_qualifier="is_qualifier"
                    :stableford="stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :ReportcolourTour="ReportcolourTour"
                    :cptTour="tournID"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Overview Section -->
      <div class="tourInfoOverview" v-if="tourinfo.tourn_desc_found == 'Y'">
          <h2 class="HeaderText">Overview</h2>
          <p class="tourndesc" v-html="tourinfo.tourn_desc">
        </p>
      </div>
      <!-- Scorecard Section -->
      <div class="showDesk">
        <h2 class="HeaderText scorecardSection">Scorecard</h2>
        <template v-if="tourinfo.multi_course === 'Y'">
          <div
            v-for="(multi, index) in tourinfo.courses.courses_entry"
            :key="'fourtysevendex' + index"
          >
            <b-row :class="courseStats">
              <b-col>
                <div class="table-responsive">
                  <table class="courseinfo">
                    <thead>
                      <tr class="title" :class="multi.course_X_colour">
                        <th class="titleText">Hole</th>
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>
                        <th>5</th>
                        <th>6</th>
                        <th>7</th>
                        <th>8</th>
                        <th>9</th>
                        <th>out</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>13</th>
                        <th>14</th>
                        <th>15</th>
                        <th>16</th>
                        <th>17</th>
                        <th>18</th>
                        <th>In</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="titleText">Par</td>
                        <td
                          v-for="(number, index) in multi.course_X_par
                            .split(',')
                            .slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td>
                          {{ multi.course_X_out_par.slice(1, 5) }}
                        </td>
                        <td
                          v-for="(number, index) in multi.course_X_par
                            .split(',')
                            .slice(9, 18)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td>
                          {{ multi.course_X_in_par.slice(1, 5) }}
                        </td>
                        <td>
                          {{ multi.course_X_total_par }}
                        </td>
                      </tr>
                      <tr>
                        <td class="titleText">Yards</td>
                        <td
                          class="title"
                          v-for="(number, index) in multi.course_X_length_yards
                            .split(',')
                            .slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td class="title">
                          {{ outVal(multi.course_X_length_yards) }}
                        </td>
                        <td
                          class="title"
                          v-for="(number, index) in multi.course_X_length_yards
                            .split(',')
                            .slice(9, 18)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td class="title">
                          {{ inVal(multi.course_X_length_yards) }}
                        </td>
                        <td class="title">
                          {{ totalVal(multi.course_X_length_yards) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="titleText">Meters</td>
                        <td
                          v-for="(number, index) in multi.course_X_length_meters
                            .split(',')
                            .slice(0, 9)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td>
                          {{ outVal(multi.course_X_length_meters) }}
                        </td>
                        <td
                          v-for="(number, index) in multi.course_X_length_meters
                            .split(',')
                            .slice(9, 18)"
                          :key="index + Math.random()"
                        >
                          {{ number }}
                        </td>
                        <td>
                          {{ inVal(multi.course_X_length_meters) }}
                        </td>
                        <td>
                          {{ totalVal(multi.course_X_length_meters) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </div>
        </template>
        <template v-if="tourinfo.multi_course === 'N'">
          <b-row :class="courseStats">
            <b-col>
              <div class="table-responsive">
                <table class="courseinfo">
                  <thead>
                    <tr class="title">
                      <th class="titleText">Hole</th>
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                      <th>5</th>
                      <th>6</th>
                      <th>7</th>
                      <th>8</th>
                      <th>9</th>
                      <th>out</th>
                      <th>10</th>
                      <th>11</th>
                      <th>12</th>
                      <th>13</th>
                      <th>14</th>
                      <th>15</th>
                      <th>16</th>
                      <th>17</th>
                      <th>18</th>
                      <th>In</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="titleText"><span class="firstOption">Par</span></td>
                      <td
                        v-for="(number, index) in tourinfo.course_par
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td>
                        {{ tourinfo.course_out_par.slice(1, 5) }}
                      </td>
                      <td
                        v-for="(number, index) in tourinfo.course_par
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td>
                        {{ tourinfo.course_in_par.slice(1, 5) }}
                      </td>
                      <td>
                        {{ tourinfo.course_total_par }}
                      </td>
                    </tr>
                    <tr>
                      <td class="title titleText"> <span class="firstOption">Yards</span></td>
                      <td
                        class="title"
                        v-for="(number, index) in tourinfo.course_length_yards
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td class="title">
                        {{ outVal(tourinfo.course_length_yards) }}
                      </td>
                      <td
                        class="title"
                        v-for="(number, index) in tourinfo.course_length_yards
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td class="title">
                        {{ inVal(tourinfo.course_length_yards) }}
                      </td>
                      <td class="title">
                        {{ totalVal(tourinfo.course_length_yards) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="titleText"><span class="firstOption">Meters</span></td>
                      <td
                        v-for="(number, index) in tourinfo.course_length_meters
                          .split(',')
                          .slice(0, 9)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td>
                        {{ outVal(tourinfo.course_length_meters) }}
                      </td>
                      <td
                        v-for="(number, index) in tourinfo.course_length_meters
                          .split(',')
                          .slice(9, 18)"
                        :key="index + Math.random()"
                      >
                        {{ number }}
                      </td>
                      <td>
                        {{ inVal(tourinfo.course_length_meters) }}
                      </td>
                      <td>
                        {{ totalVal(tourinfo.course_length_meters) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </template>
      </div>

      <!-- Tournament Gallery Section -->
      <div class="gallerySection" v-if="tournGallaryData.Message != 'Not Found'">
        <Gallery
          :code="course_code"
          :season="id"
          :config="config"
          :tournID="tournID"
        />
      </div>

      <!-- News Section -->
      <div class="tournamentNews" v-if="showNews == true">
        <b-row class="tournNews" >
          <b-col sm="12" lg="6">
            <h2 class="HeaderText">Tournament News</h2>
          </b-col>
          <!-- <b-col sm="12" lg="6">
            <b-link to="/news" class="allNewsLink">
              <button class="Allbuttons">
                See More News
              </button>
            </b-link>
          </b-col> -->
        </b-row>
        <Post 
          :tag=" this.wptag[0].id" 
          :course_code="course_code"
          :config="config"
        />
      </div>
    </b-container>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportTable from "@/components/reportTable.vue";
import { HBH, ScoreTeam } from "@ocs-software/vue-ocs";
import Post from "@/components/posts.vue";
import Gallery from "@/components/Gallerysection.vue";
import axios from 'axios';
export default {
  name: "Tournament",
  components: { ReportTable, HBH, ScoreTeam, Post, Gallery },
  props: ["course_code", "id", "config",],
  data() {
    return {
      tourinfo: [],
      class_group: '',
      splash: "splash",
      splashText: "splashText",
      logo: "logo",
      overlay: "overlay",
      courseStats: "courseStats",
      title: "",
      report: "",
      data: [],
      wptag: "",
      imagefiles: [],
      ListlastURL: '',
      ReportTitleText: null,
      hideLoader: false,
      tournID : this.$route.query.tour,
      // tournID : 'mena',
      tagId: this.tagid,
      countPost: '',
      showNews: false,
      tournGallaryData: [],
      prizeFundData: [],
      prizeFundDataName: '',
      showFund: false,
      imageAlbumList: [],
      playerImages: [],
    };
  },
  methods:{
    gettournPosts: function() {
      console.log("InPost")
      return axios.get(
        'https://wp-cpt.ocs-software.com/wp-json/wp/v2/' +
          "tags?slug=" + this.id + this.tourinfo.code + "&randomadd=" + new Date().getTime()
        )
      .then(response => {
        this.wptag = response.data;
        this.tagId = response.data[0].id;
        if (this.wptag[0].count > 0) {
          this.showNews = true
        }
      });
    },
    getsmugImages: function() {
      console.log("SMUG IMAGES")
      this.playerImages = [];
      console.log("this.playerImages")
      console.log(this.playerImages)
      var playerCode
      if (this.tourinfo.winner_found == 'Y') {
        playerCode = this.tourinfo.winner_code;
      } else {
        playerCode = this.previous_winners.previous_winners_entry.cc_code_1;
      }
        // this.playerData = i;
        axios .get('https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' + encodeURIComponent(btoa('https://api.smugmug.com/api/v2/folder/user/andycrook/Clutch-Pro-Tour/Profile/Scorecards/' + playerCode + '!albumlist' + '?APIKey=' + 'GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2' + '&_accept=application/json')))
        .then(response => {
          this.fullAlbumList = response.data;
          this.imageAlbumList = response.data.Response.AlbumList
          console.log("this.imageAlbumList")
          console.log(this.imageAlbumList)       
          this.imageAlbumList.forEach((value2) => {
              axios .get('https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' + encodeURIComponent(btoa('https://api.smugmug.com' + value2.Uri + '!images' + '?APIKey=' + 'GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2' + '&_accept=application/json')))
              .then(response => {
                try {
                  this.scoreImage = response.data.Response.AlbumImage
                  this.playerImages = []
                  this.scoreImage.forEach((value) => {
                      this.playerImages.push({
                        'smug_thumbnail': value.ThumbnailUrl,
                        'smug_web_url': value.WebUri
                      });
                  }) 
                } catch (error) {
                  console.log(error)
                }
              })
          })
          // break
        });       
    },
    changeReport: function(event) {
      var report = event.target.getAttribute("title");
      var title = event.target.getAttribute("value");
      (this.report = report), (this.title = title);
      return apiCall
        .report(this.reportTitleChange)
        .then(({ data }) => {
          this.data = data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          throw error;
        });
    },
    outVal(value) {
      var split = value.split(",");
      var front9 = split.slice(0, 9);
      for (var i = 0; i < front9.length; i++) front9[i] = +front9[i];
      var sum = front9.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    inVal(value) {
      var split = value.split(",");
      var back9 = split.slice(9, 18);
      for (var i = 0; i < back9.length; i++) back9[i] = +back9[i];
      var sum = back9.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    totalVal(value) {
      var split = value.split(",");
      for (var i = 0; i < split.length; i++) split[i] = +split[i];
      var sum = split.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    reportTitleFun() {
      let repT = this.ListlastTite;
      if (Array.isArray(this.tourinfo.reports.reports_entry)) {
        this.title = repT;
        console.log("this.title")
        console.log(this.title)
      } else {
        this.title = 'Tournament Entries';
        // console.log("this.title")
        // console.log(this.title) 
      }
    },
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    },
  },
  computed: {
    // mapRef: function() {
    //   if (this.tourinfo.clubs.length)
    //     return this.tourinfo.clubs.clubs_entry.rep;
    //   else return this.tourinfo.course_name;
    // },
    colourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0'
      } else if (this.tournID == 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2;color: #081C3F'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = "background-color: #c3bcce;color: #081C3F"
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'background-color: #c96b6b;color: #fff'
      }
      return backgroundColourTour
    },
    ReportcolourTour: function() {
      var backgroundColourTour = '';
      if (this.tournID == 'cpt') {
        backgroundColourTour = 'background-color: #bceff0; color:#081C3F'
      } else if (this.tournID == 'cp2') {
        backgroundColourTour = 'background-color: #bde9d8; color:#081C3F'
      } else if (this.tournID == 'cp3') {
        backgroundColourTour = 'background-color: #dfc3c2; color: #081C3F'
      } else if (this.tournID == 'pam') {
        backgroundColourTour = "background-color: #c3bcce;color: #081C3F"
      } else if (this.tournID == 'qsc') {
        backgroundColourTour = 'background-color: #ededc3'
      } else if (this.tournID == 'por') {
        backgroundColourTour = 'background-color: #c96b6b; color:#fff'
      }
      return backgroundColourTour
    },
    teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
    filterReports: function() {
      if (Array.isArray(this.reports)) {
        return this.reports.filter(
          (reports_entry) =>
            reports_entry.report_title.includes("Tournament Entries") ||
            reports_entry.report_title.includes("Score") ||
            reports_entry.report_title.includes("Draw") ||
            reports_entry.report_title.includes("Final")
        );
      } else return this.reports; 
    },
    currentReport: function() {
      if (Array.isArray(this.filterReports))
        return this.filterReports[this.filterReports.length - 1].report_url;
      else return this.filterReports.report_url;
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
          this.id +
          "/" +
          this.id +
          "-" +
          this.course_code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );
          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
    reportTitleChange: function(url) {
      if (this.report.indexOf("tmentry") !== -1) {
        url =
          'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
          this.id +
          "/" +
          this.id +
          "-" +
          this.course_code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.report.indexOf("tmscore") !== -1) {
          var subRep2 = this.report.lastIndexOf("params=") + 7;
          var indNext2 = this.report.indexOf("~", subRep2);
          var repParams = this.report.substr(
            subRep2,
            indNext2 - subRep2
          );
          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.report.indexOf("tmlsmon") !== -1) {
          {
            url =
              'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.course_code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.report.indexOf("tmdraw") !== -1) {
          var subRep = this.report.lastIndexOf("round=") + 6;
          var indNext = this.report.indexOf("~", subRep);
          var drawRnd = this.report.substr(subRep, indNext - subRep);
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.report.indexOf("tmresult") !== -1) {
          var subRep1 = this.report.lastIndexOf("result=") + 7;
          var indNext1 = this.report.indexOf("~", subRep1);
          var resNum1 = this.report.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            'https://api.euro.ocs-software.com/cpt/cache/' + this.tournID +'/' +
            this.id +
            "/" +
            this.id +
            "-" +
            this.course_code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    }
  },
  // created(id, code) {
  //   id = this.id
  //   code = this.course_code
  //   apiCall
  //     .tmParams(id, code)
  //     .then(({ data }) => {
  //       this.tourinfo = data;
  //       this.loading = false;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       throw error;
  //     });
  // },
  async mounted(id, code) {
    id = this.id
    code = this.course_code
    this.tournID = this.$route.query.tour
    try {
      // First call, await for call to return
      let first_call = await apiCall.tmParams(id, code, this.tournID)
      this.tourinfo = first_call.data;
      this.prizefundAlldata = first_call.data.prize_funds;
      if (this.prizefundAlldata != '') {
        if (first_call.data.show_prize_fund.length > 0 && first_call.data.show_prize_fund == 'W' || first_call.data.show_prize_fund == 'B') {
          this.showFund = true;
          this.prizeFundData = first_call.data.prize_funds.fund.prizes.prize; 
          this.prizeFundDataName = first_call.data.prize_funds.fund.fund_name; 
        }        
      }

      // this.reports = first_call.data.reports.reports_entry;
      if (first_call.data.reports != '') {
        this.reports = first_call.data.reports.reports_entry       
      }
      // this.imagefiles = first_call.data.ad_files;
      if (Array.isArray(first_call.data.ad_files.ad_file_details)) {
        this.imagefiles = first_call.data.ad_files.ad_file_details
      } else {
        this.imagefiles = [first_call.data.ad_files.ad_file_details]
      }
      this.until = first_call.data.days_away;
      this.showGender = first_call.data.show_gender;
      this.is_qualifier = first_call.data.is_qualifier;
      this.stableford = first_call.data.stableford;
      this.show_info_web = first_call.data.tm_params.show_info_web;
      this.hide_score_card = first_call.data.hide_score_card;
      this.class_group = first_call.data.class_group;
      this.loading = false;
      let second_call = await apiCall.report(this.reportTitle);
      this.data = second_call.data;
      console.log("this.data")
      console.log(this.data)
      if (Array.isArray(this.tourinfo.reports.reports_entry)) {
        let arr = [];
        let arrURL = [];
        this.tourinfo.reports.reports_entry.forEach((value) => {
            if (value.report_title.includes('Entries') || value.report_title.includes('Draw') || value.report_title.includes('Score') || value.report_title.includes('Final')) {
                arr.push(value.report_title) 
                arrURL.push(value.report_url) 
            }
        });
        this.lastListTitle = arr.slice(-1);
        this.ListlastTite = this.lastListTitle[0];
        this.lastListURL = arrURL.slice(-1);
        this.ListlastURL = this.lastListURL[0];
        this.ReportTitleText = setTimeout(() => {
          this.hideLoader = true;
          this.reportTitleFun();
        }, 3000);
      } else {
        this.ReportTitleText = setTimeout(() => {
          this.hideLoader = true;
          this.reportTitleFun();
        }, 3000);
      }
      this.gettournPosts();
      this.getsmugImages();
      // Second call
    } catch (error) {
      console.log("error in await calls");
      console.log(error);
      throw error;
    }
  },
};
</script>

<style scoped>
@media (min-width: 576px) {
    ::v-deep .modal-dialog {
        max-width: 800px;
        margin: 1.75rem auto;
    }
}
::v-deep th.mobileTab {
  width: 25%;
}
::v-deep .close {
  float: right;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1;
  color: #081c3f;
  text-shadow: 0 0px 0 #fff;
  opacity: 01;
  background: #fff !important;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 800px;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  height: 800px;
  overflow: scroll;
}
::v-deep body.fundBReak {
  display: contents;
}
::v-deep body.fundBReak {
  display: contents;
}
::v-deep body.fundBReak > tr > td{
  text-align: center;
}
::v-deep .fade {
    opacity: 1;
    -webkit-transition: opacity;
    -o-transition: opacity .15s linear;
    transition: opacity;
}
button#show-btn {
  background-color: #fff;
  color: #081b3f;
  width: 220px;
  text-align: center;
  border-radius: 26px;
  border: none;
  height: 30px;
  /* margin-left: 15px; */
  margin-left: 8px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-size: 16px;
}
button#show-btn:hover {
  background-color: #081C3F;
  color: #fff;
  width: 220px;
  text-align: center;
  border-radius: 26px;
  border: 1px solid #fff;
  height: 30px;
  /* margin-left: 15px; */
  margin-left: 8px;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-size: 16px;
}
.top::before {
  content: "";
  position: absolute;
  width: 100%;
  max-height: 700px;
  height: 691px;
  top: 10em;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
::v-deep button#dropdown-1__BV_toggle_ {
  width: 100%;
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 424px;
  height: 52px;
  border-radius: 26px;
}
::v-deep .dropdown-toggle::after {
  float: right;
  position: relative;
  top: 10px;
}
::v-deep .btn {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  width: 424px;
  height: 52px;
}
::v-deep .btn-secondary {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  border-radius: 26px;
}
::v-deep .btn-secondary:hover {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:active {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 100%;
  width: 424px;
  height: 52px;
}
::v-deep .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 18px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  width: 424px;
}
div#dropdown-1 {
  width: 424px;
  height: 52px;
  text-align: left;
  float: right;
  border-radius: 0px;
}
.tourBox {
  background-color: #00FFFE;
  width: 169px;
  height: 51px;
  text-align: center;
  font-size: 20px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #081C3F;
  line-height: 2.5;
  margin-bottom: 30px;
  margin-top: 8%;
  border-radius: 26px;
}
h2.HeaderText.reportInfo.loadReports {
  padding-right: 0;
  padding-top: 30px;
}
.insideLoader {
  margin: auto;
  text-align: center;
  display: block;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #081C3F;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  margin-top: 30px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
p.winnerName {
  color: #263056;
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
}
::v-deep .dropdown-item {
  color: #081C3F!important;
}
.reportSele.extraMargin {
  margin-top: 50px;
}
.noPadTop {
  padding-left: 0;
}
.dicDates {
  border-radius: 30px;
  background-color: #081C3F;
  color: #fff;
  width: 175px;
  height: 30px;
  font-size: 20px;
  margin-bottom: 30px;
}
::v-deep .logoImage {
  height: 360px;
  /* width: 102px; */
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.row.imagefilesPos {
  position: absolute;
  width: 100%;
  top: 35em;
}
.imagefileImage {
  height: 80px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  /* background-position: 50%; */
  width: 200px;
  margin: auto;
}
.outerBorderImage {
  border-radius: 50%;
  height: auto;
  width: auto;
  /* opacity: 0.9; */
  margin-top: 0px;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
  background-repeat: no-repeat;
  background-size: contain;
}
h3.HeaderText.space {
  padding-bottom: 30px;
}
a.websiteLink {
  width: 20px;
  display: inline-block;
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.marginRow {
  padding-top: 30px;
}
.showMobile > h2.date-width {
  color: #fff;
  z-index: 999;
  position: relative;
  margin-top: 20px !important;
}
.showMobile > h2.fullName-width {
  color: #fff;
  z-index: 999;
  position: relative;
}
.overflowImage.newsSmallImage {
  height: 190px;
  border-radius: 25px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
div#reportTable {
  height: 600px;
  overflow: scroll;
}
.tournNews {
  padding-bottom: 30px;
  padding-top: 30px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);  
}
h2.HeaderText.scorecardSection {
  padding-top: 100px;
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #ffffff!important;
  background-color: #081C3F;
  border-color: #081C3F #081C3F #fff;
}
::v-deep .nav-tabs .nav-link {
  margin-bottom: -2px;
  border: 0px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
::v-deep table.scores-only-table > thead > tr > th:first-child {
  border-radius: 0px;
}
::v-deep table.scores-only-table > thead > tr > th:last-child {
  border-top-right-radius: 0px;
}
::v-deep .mt-3, .my-3 {
  margin-top: 0rem !important;
}
::v-deep .hbh table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 0px solid #ddd;
  font-weight: bold;
  color: white;
  font-size: 16px;
  text-transform: capitalize;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  /* background: #1a2338; */
  color: #ffffff !important;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 0px !important;
}
::v-deep .TitleArea {
  display: none;
}
::v-deep th:first-child {
  text-align: center;
}
::v-deep div#entries > div {
  display: none;
}
::v-deep div#draw > div {
  display: none;
}
::v-deep div#score > div {
  display: none;
}
::v-deep div#Results > div {
  display: none;
}
::v-deep div#hbh > div > div {
  display: none;
}
::v-deep div#reportTable > div {
  display: none;
}
h2.HeaderText.reportInfo {
  color: #081C3F;
  font-weight: 600;
  font-size: 26px;
  padding-right: 2em;
  position: relative;
  top: 9px;
}
.reportdrop {
  display: inline-flex;
  text-align: center;
  margin: auto;
  position: relative;
  left: 24em;
  margin-bottom: 40px;
}
img.sponsorImage {
  /* width: 100%; */
  width: 400px;
  max-width: fit-content;
  /* position: relative; */
  /* top: 40px; */
  top: 0px;
  left: 65px;
  position: absolute;
}
h2.date-width {
  font-size: 20px;
  font-weight: bold;
  margin-top: 40px;
  text-align: center;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
}
a.playerProfileLink {
  color: #081C3F!important;
  font-size: 18px;
  font-weight: bold;
  /* position: relative;
  top: 50px; */
  text-align: center;
  margin: auto;
  display: block;
  /* margin-top: 36px; */
  margin-top: 22px;
}
a.playerProfileLink:hover {
  color: #707070!important;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  /* position: relative;
  top: 50px; */
  text-align: center;
  margin: auto;
  display: block;
  /* margin-top: 36px; */
  margin-top: 22px;
}
img.insideflag {
  width: 25px;
  text-align: center;
  margin: auto;
  display: block;
}
.imagePad {
  padding-right: 0;
}
.winnerNameBlock {
  background: #fff;
  /* border-bottom-left-radius: 6px;  */
  border-bottom-right-radius: 6px;
}
.noPadLeft.col-lg-12 {
  padding-left: 0;
}
.courseInformation {
  /* padding-left: 15px; */
  padding-top: 30px;
}
span.firstOption {
  position: relative;
  left: 31px;
  color: #081C3F;
  font-weight: bold;
  font-size: 18px;
}
.title {
  text-align: center;
  background-color: #F8F8F8;
  color: #707070;
}
th {
  font-size: 18px;
}
.HeaderText {
  color: #081C3F;
  /* font-weight: 600; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 40px;
}
.backgroundGrey {
  background-color: #081C3F;
  padding-bottom: 35px;
}
.tourndesc {
  /* padding-left: 15px; */
  font-size: 16px;
  padding-top: 25px;
}
.tourInfoOverview {
  margin-top: 2em;
}
h2.tourInfoHeading{
  font-size: 25px;
  font-weight: 400;
  color: #848792;
  padding-left: 15px;
}
.noLink > a {
  display: contents;
}
.ReportsBlock {
  margin-bottom: 30px;
}
.paragraph-Padding {
  /* padding-left: 30px;
  padding-right: 30px; */
  padding-top: 30px;
  padding-bottom: 30px;
}
.top {
  /* height: 395px; */
  /* height: 600px; */
  height: 592px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.default {
  background-image: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/tourninfo.png)!important;
}
.tour {
  /* padding-top: 20px; */
}
.holes {
  padding: 0 10px;
  padding-top: 25px;
  padding-bottom: 45px;
}
.rightside-changes {
  margin-bottom: 20px;
}
h3.valuesize {
  font-size: 18px;
  color: #fff;
}
h4.courseName-width {
  font-size: 26px;
  font-weight: bold;
}
h2.fullName-width {
  width: 100%;
  font-size: 60px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
h2.fullcourse-width {
  width: 100%;
  font-size: 40px;
  font-weight: bold;
}
.splash {
  width: 100%;
}
.leftCol > .row {
  padding-left: 15px;
  padding-right: 15px;
}
.underLine {
  /* text-decoration: underline; */
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}

.courseinfo {
  width: 100%;
}

.splashText {
  margin-top: 75px;
  color: white;
}

.logo {
  /* width: 170px; */
  width: 120px;
  padding-bottom: 25px;
  float: right;
  margin-top: 60px;
}

.overlay {
  margin-top: 3em;
  /* background-color: rgba(38, 48, 86, 0.6); */
  /* padding-left: 4%;
  padding-top: 4%; */
}

.splashPad {
  text-align: left;
  color: #fff;
  /* background-color: #081C3F; */
  /* font-weight: 600; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 40px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.MainInfo {
  padding-left: calc(3vw + 3vh);
  padding-top: calc(2vw + 2vh);
  padding-right: calc(3vw + 3vh);
  padding-bottom: calc(2vw + 2vh);
}

.courseStats {
  padding: 14px;
  margin-bottom: 2em;
  margin-top: 1em;
}

.rowPad {
  padding-bottom: 1%;
}
tr:nth-of-type(odd) {
  background-color: #fff!important;
}
thead > tr {
  background-color: white !important;
  font-weight: bold;
  font-size: 16px !important;
  border: 0px solid;
}
td:first-child {
  text-align: left;
}
::v-deep tr {
  border-bottom: 0px solid #E8E8E8;
}
td {
  padding-top: 12px !important;
  padding-right: 6px !important;
  padding-bottom: 12px !important;
  vertical-align: middle;
  font-size: 16px !important;
  color: #707070;
}
.reportButton {
  font-size: calc(0.5vh + 0.5vw);
  /* padding-left: 0; */
  /* margin-top: 0; */
  display: block;
  text-align: center;
  background: #081C3F;
  color: #fff;
  margin-bottom: 15px;
}
.reportButton:hover {
  font-size: calc(0.5vh + 0.5vw);
  /* padding-left: 0; */
  /* margin-top: 0; */
  display: block;
  text-align: center;
  background: #337ab7;
  color: #fff;
  margin-bottom: 15px;
}
.reportButton > a {
  text-decoration: none!important;
  color: #fff!important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.courseStats > .col:first-child {
  padding-right: 0;
}
.courseStats > .col:last-child {
  padding-left: 0;
}
.mainImg {
  /* max-width: 100%; */
  width: 100%;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

#gmap_canvas {
  height: 300px;
  width: 300px;
}
.desc {
  font-size: 14px;
  padding: 35px;
}
  .showMobile {
    display: none;
  }
@media only screen and (max-width: 1199px) {
  .top::before {
    display: none;
  }
  .reportdrop {
    display: inline-flex;
    text-align: center;
    margin: auto;
    position: relative;
    left: 0em;
    margin-bottom: 40px;
  }
  span.firstOption {
    position: relative;
    left: 0;
    color: #081C3F;
    font-weight: bold;
    font-size: 18px;
  }
  .imageSize.col-sm-6.col-lg {
    flex: 0 0 50%;
    max-width: 50%; 
  }
  img.sponsorImage {
    width: -webkit-fill-available;
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    /* position: relative; */
    /* top: 40px; */
    top: 0px;
    left: 65px;
    position: absolute;
  }
  .row.imagefilesPos {
    position: inherit;
    width: 100%;
    top: 31em;
  }
  a.playerProfileLink {
    color: #081C3F !important;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin: auto;
    display: block;
    /* margin-top: 36px; */
    margin-top: 12px;
  }
}
@media only screen and (max-width: 1024px) {
  #gmap_canvas {
    height: 250px;
    width: 200px;
  }
  .splash {
    height: 300px;
  }
  .top {
    /* height: 300px; */
  }
  .splashText {
    /* margin-top: -25%; */
  }

  .splashPad {
    padding-top: 4%;
    padding-bottom: 4%;
  }
  h2 {
    font-size: 1.5em;
  }
  h3 {
    font-size: 1.3em;
  }
  h4 {
    font-size: 1em;
  }
}
@media only screen and (min-width: 991px) {
  .below990 {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  .dropdown.b-dropdown.btn-group {
    width: 100%;
    padding-left: 5px;
    padding-right: 7px;
  }
  .tourBox{
    margin-top: 25px;
  }
  p.winnerName {
    color: #263056;
    font-size: 18px;
    font-weight: 600;
    margin-top: 30px;
    text-align: center;
  }
  .above990 {
    display: none;
  }
  h2.HeaderText.reportInfo {
    color: #081C3F;
    font-weight: 600;
    font-size: 26px;
    padding-right: 0em;
    position: relative;
    top: 9px;
    text-align: center;
  }
  .justify-content-center {
    text-align: left;
  }
  .splashText {
    margin-top: 0px;
    color: white;
  }
  .overlay {
    margin-top: 30%;
  }
  li.nav-item.nonactive.HBH {
    display: none;
  }
  .paraText {
  }
  .showMobile {
    padding: 20px;
  }
  .top:before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 5em;
    background-color: rgba(0, 0, 0, 0.5);
  }
  h2.fullName-width {
    width: 100%;
    /* font-size: 28px; */
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
    color: #fff;
  }
  .mainImg {
    /* max-width: 100%; */
    width: 100%;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: 0px;
  }
  h2.date-width {
    /* font-size: 15px; */
    font-weight: bold;
    margin-top: 130px;
  }
  .winnerNameBlock {
    background: #fff;
    border-bottom-left-radius: 6px; 
    border-bottom-right-radius: 6px;
    padding-bottom: 25px;
    border-top-right-radius: 0px;
    border: 1px solid #263057;
    border-top: 0px;
  }
  ::v-deep button.btn.dropdown-toggle.btn-secondary {
    margin-top: 30px;
    border-radius: 26px;
    width:100%;
  }
  .reportdrop {
    display: block;
    text-align: left;
    margin: auto;
    position: relative;
    margin-bottom: 40px;
    left: 0;
  }
  .showDesk {
    display: none
  }
  .HeaderText {
    text-align: left;
    color: #081C3F;
    /* font-weight: 600; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    font-size: 40px;
    padding-top: 20px;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #081C3F;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin: auto;
    margin-top: 30px!important;
    display: block;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin: auto;
    margin-top: 30px!important;
    display: block;
    transform: translateY(-10px);    
  }
}
@media only screen and (max-width: 768px) {
  .holes {
    padding: 0 10px;
    padding-top: 15px;
    padding-bottom: 45px;
  }
  td {
    /* padding-top: 11px !important; */
    padding-right: 6px !important;
    /* padding-bottom: 11px !important; */
    vertical-align: middle;
    font-size: 16px !important;
  }
  #gmap_canvas {
    height: 250px;
    width: 300px;
  }
  .splashText {
    margin-top: -31%;
  }
  thead > tr > th {
    padding-top: 11px !important;
    padding-bottom: 11px !important;
  }
  .overlay{
    margin-top: 55%;
  }
  .noPadLeft.col-lg-12 {
    /* padding-left: 15px; */
  }
}
@media only screen and (max-width: 510px) {
  /* ::v-deep .top::before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    top: 5em;
    background-color: rgba(0, 0, 0, 0);
  } */
  .noPadTop {
    padding-left: 15px;
    /* display: none; */
  }
  div#reportTable {
    height: 600px;
    overflow: scroll;
    margin-bottom: 100px;
  }
  .leftCol > .row {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media only screen and (max-width: 520px) {
  ::v-deep th.mobileTab {
    font-size: 14px;
  }
  ::v-deep td.mobileTab {
    font-size: 14px!important;
  }
  ::v-deep .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #081C3F;
    background-color: transparent;
    border-color: #081C3F;
    width: 100%;
    width: 424px;
    height: 52px;
  }
  button#show-btn {
    background-color: #fff;
    color: #081b3f;
    font-weight: bold;
    width: 220px;
    text-align: center;
    border-radius: 26px;
    border: none;
    height: 30px;
    margin-left: 0px;
    margin-bottom: 15px;
  }
  .hideOnMobile {
    display: none;
  }
  ::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 75%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    height: 450px;
    overflow: scroll;
    margin: auto;
  }
  ::v-deep .modal-dialog {
    position: relative;
    width: auto;
    margin: 0.5rem;
    pointer-events: none;
    margin-top: 13em;
  }
}
@media only screen and (max-width: 480px) {
  ::v-deep .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: none;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 18px;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    width: 100%;
    margin: auto;
    /* margin-left: 3.25em; */
  }
  h2.fullName-width {
    width: auto;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
  .splash {
    height: 175px;
  }
  .top {
    height: 500px;
  }

  h2 {
    font-size: 1.7em;
  }
  h3 {
    font-size: 1.5em;
  }
  h4 {
    font-size: 1.3em;
  }
  .reportButton {
    font-size: 1em;
    margin-right: 10px;
  }
  .reportRow {
    padding-bottom: 10%;
  }
  .logo {
    width: 80px;
    padding: 12px;
  }
  .top {
    height: 175px;
  }
  .splashText[data-v-14fba303] {
    margin-top: -38%;
  }
  .row {
    margin: 0;
  }
  .col-1,
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-10,
  .col-11,
  .col-12,
  .col,
  .col-auto,
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm,
  .col-sm-auto,
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md,
  .col-md-auto,
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg,
  .col-lg-auto,
  .col-xl-1,
  .col-xl-2,
  .col-xl-3,
  .col-xl-4,
  .col-xl-5,
  .col-xl-6,
  .col-xl-7,
  .col-xl-8,
  .col-xl-9,
  .col-xl-10,
  .col-xl-11,
  .col-xl-12,
  .col-xl,
  .col-xl-auto {
    padding-left: 0;
    padding-right: 0;
  }
}
@media only screen and (max-width: 375px) {
  ::v-deep .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: none;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 18px;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    width: 100%;
    margin: auto;
    margin-left: 3.25em;
  }
}
</style>
